import { render, staticRenderFns } from "./appComponent.vue?vue&type=template&id=7f5ec40b&"
import script from "./appComponent.vue?vue&type=script&lang=js&"
export * from "./appComponent.vue?vue&type=script&lang=js&"
import style0 from "./appComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports